'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UILink from 'UIComponents/link/UILink';
import PortalIdParser from 'PortalIdParser';

const WebsiteAudiencePrivacyPolicy = () => /*#__PURE__*/_jsx(UIFormControl, {
  label: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ADS_ACCOUNT_CONNECTION.audiences.websitePrivacyPolicy.privacyPolicy"
  }),
  tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "ADS_ACCOUNT_CONNECTION.audiences.websitePrivacyPolicy.tooltip"
  }),
  children: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "ADS_ACCOUNT_CONNECTION.audiences.websitePrivacyPolicy.message",
    options: {
      link: /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: `/settings/${PortalIdParser.get()}/analytics-and-tracking/cookies`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ADS_ACCOUNT_CONNECTION.audiences.websitePrivacyPolicy.link"
        })
      })
    }
  })
});

export default WebsiteAudiencePrivacyPolicy;